import React, { useEffect, useState, useRef } from 'react';
import { MCButton, MCText, TextField } from './basic';
import LANG_CONST from '../helpers/lang/const';
import { BASE_ICONS } from './svg';
import { Link } from 'react-router-dom';
import { formatPhoneNumberIntl } from 'react-phone-number-input';
import { remCss } from 'src/helpers';

export const EmailPhone = ({ item, emailWeight = 500 }) => {
  return (
    <div className={'mc-flex-5-col'}>
      <MCText label={item.email} numberOfLines={1} heading size={18} weight={emailWeight} />
      <MCText
        label={formatPhoneNumberIntl((item.phoneNumber || '').toString())}
        numberOfLines={1}
        heading
        size={18}
      />
    </div>
  );
};

export const FormRow = ({ children, addColspan = 0, addPreColspan = 0, style = {} }) => {
  return (
    <div className={'mc-flex-20 mc-flex-start'} style={{ maxWidth: remCss(1000), ...style }}>
      {Array.from({ length: addPreColspan }, (a, v) => (
        <div className={'mc-grow'} key={v} />
      ))}
      {Array.isArray(children) ? (
        children.map((item, i) => (
          <div className={'mc-grow'} key={i}>
            {item}
          </div>
        ))
      ) : (
        <div className={'mc-grow'}>{children}</div>
      )}
      {Array.from({ length: addColspan }, (a, v) => (
        <div className={'mc-grow'} key={v} />
      ))}
    </div>
  );
};

export const EmailPhoneSection = ({
  emailReadonly,
  phoneReadonly,
  email,
  phoneNumber,
  handleBlur,
  invalid,
  defaultCountryName,
  handleChangeProfile
}) => (
  <FormRow>
    <TextField
      template={6}
      label={LANG_CONST.email}
      name={'email'}
      value={email}
      onChange={handleChangeProfile}
      onBlur={handleBlur}
      invalid={invalid}
      {...(emailReadonly
        ? {
            readOnly: true,
            suffixEl: (
              <Link
                type={'link'}
                to={'/settings/security'}
                style={{ position: 'absolute', width: '100%' }}
              >
                <MCButton
                  quaternary
                  transparent
                  radius
                  iconname={BASE_ICONS.EDIT}
                  hover={false}
                  padding={1}
                  width={45}
                  style={{ marginRight: 5, float: 'right' }}
                />
              </Link>
            )
          }
        : {})}
    />
    <TextField
      template={6}
      defaultCountryName={defaultCountryName}
      name={'phoneNumber'}
      type='phone'
      value={phoneNumber}
      onChange={handleChangeProfile}
      onBlur={handleBlur}
      label={LANG_CONST.phone_number}
      invalid={invalid}
      {...(phoneReadonly
        ? {
            readOnly: true,
            suffixEl: (
              <Link
                type={'link'}
                to={'/settings/security'}
                style={{ position: 'absolute', width: '100%' }}
              >
                <MCButton
                  quaternary
                  transparent
                  radius
                  iconname={BASE_ICONS.EDIT}
                  hover={false}
                  padding={1}
                  width={45}
                  style={{ marginRight: 5, float: 'right' }}
                />
              </Link>
            )
          }
        : {})}
    />
  </FormRow>
);

export const ExpandAnimationComponent = ({ show, children, style, dropdown = false }) => {
  const [shouldRender, setRender] = useState(show);
  const [open, setOpen] = useState(show);
  const renderTimerRef = useRef(null);

  useEffect(() => {
    // Avoid calling setState synchronously inside the effect because React
    // can warn about cascading renders. Schedule the update asynchronously
    // (next tick) so the state change doesn't happen synchronously during
    // the effect cleanup/commit phase.
    if (show) {
      // Use a macrotask to defer the state update; clear on cleanup.
      setRender(true);
      renderTimerRef.current = setTimeout(() => setOpen(true), 100);
    } else {
      setOpen(false);
      renderTimerRef.current = setTimeout(() => setRender(false), 300);
    }

    return () => {
      if (renderTimerRef.current) {
        clearTimeout(renderTimerRef.current);
        renderTimerRef.current = null;
      }
    };
  }, [show]);

  if (!dropdown)
    return (
      <div className={`mc-updown-panel ${open ? 'open' : ''}`}>{shouldRender && children}</div>
    );

  return (
    <div
      style={{
        ...style
      }}
      className={`mc-dropdown-menu ${open ? 'open' : ''}`}
    >
      <div className={'mc-dropdown-menu-list'}>{shouldRender && children}</div>
    </div>
  );
};
